// TODO: Batch uploader integrator for hospitals.
import WebWorkerController from '@controllers/WebWorkerController';

// Call it just to clean the database.
WebWorkerController.getInstance();
